module.exports = __webpack_public_path__ + "img/package-logo.2bd11f7.png";